/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, JSX, CanBeSignals, iterChildren, PropsWithChildren} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {Container as PixiContainer} from 'pixi.js';

export type Selector = string | string[] | ((item: PixiContainer) => boolean);
export type SelectChildProps = CanBeSignals<{
    /**
     * Selector to filter children array.
     * Can be filtered bay `string`, `strong[]` that wil be used for `DisplayObject.name`.
     * Or a filter function.
     */
    selector: Selector;
}>;

type ForEachCallback = (item: PixiContainer, selected: boolean) => void;

export function forEachSelectorChildren(props: PropsWithChildren<SelectChildProps>, cb: ForEachCallback): void {
    const selector = getProp(props.selector);
    const children = getProp(props.children);

    if (typeof selector === 'string') {
        for (const child of iterChildren(children)) {
            cb(child, child.name === selector);
        }
    } else if (Array.isArray(selector)){
        for (const child of iterChildren(children)) {
            cb(child, selector.includes(child.name));
        }
    } else {
        for (const child of iterChildren(children)) {
            cb(child, selector(child));
        }
    }
}

/**
 * Return only some of the direct children of this component based on selector.
 * Direct children will be filtered by `name`, `name[]` or by filter function.
 */
export const $SelectChild: FC<SelectChildProps> = (props) => {
    return Store.computed(() => {
        const children: JSX.Element = [];

        forEachSelectorChildren(props, (item, isSelected) => {
            if (isSelected) {
                children.push(item);
            }
        });

        return children;
    });
};